import * as _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { IMenuItem } from 'src/common/ESDataTable';
import { Client, IRoleDto } from 'src/generated_client';
import GlobalStore from 'src/stores/GlobalStore';
import DataTableStore from '../DataTableStore';

const ColumnSettingsDto = 'RoleDto';

export let DefaultRole = {
    id: '',
    isMenuOpen: false,
    menuItems: [] as IMenuItem[],
    name: '',
    usersInRole: 0,
};
export type IRole = typeof DefaultRole & IRoleDto;

export default class RolesStore {
    @observable
    public isLoading: boolean = false;
    @observable
    public roles: IRole[];
    @observable
    public selectedRole?: IRole;
    public dataTableStore: DataTableStore<IRoleDto, IRole>;

    constructor(globalStore: GlobalStore, private client: Client) {
        this.dataTableStore = new DataTableStore<IRoleDto, IRole>(
            globalStore,
            ({ filter, page, orderBy }) => client.apiRolesGet(filter, page, undefined, orderBy),
            (roles) => this.setupRoles(roles),
            (userId, columns) =>
                client.apiColumnSettingsByUserIdByTypePut(userId, ColumnSettingsDto, columns)
        );
    }

    @action.bound
    public getAllRoles(filter = '', pageNumber?: number, pageSize?: number) {
        if (!pageNumber) {
            pageNumber = 1;
        }
        if (!pageSize) {
            pageSize = 25;
        }
        this.isLoading = true;
        return this.client
            .apiRolesGet(filter, pageNumber, pageSize)
            .then((resp) => {
                runInAction(() => {
                    this.roles = resp.result.map(this.addDefaultFields);
                });
            })
            .catch(() => {})
            .finally(() => {
                runInAction(() => {
                    this.isLoading = false;
                });
            });
    }

    private setupRoles = (roles: IRoleDto[]) => {
        return roles.map((x) => this.addDefaultFields(x));
    };

    private addDefaultFields = (role: IRoleDto): IRole => {
        return { ...DefaultRole, ...role };
    };
}



// WEBPACK FOOTER //
// ./src/stores/RolesStore/RolesStore.ts